<template>
  <div class="page-wrap">
    <el-breadcrumb separator="/" class="breadcrumb">
      <el-breadcrumb-item>渠道档案</el-breadcrumb-item>
      <el-breadcrumb-item class="linkpath" @click.native="isShowAddmodal(false)">{{shoptype == 2 ? "灰名单":"黑名单"}}</el-breadcrumb-item>
      <el-breadcrumb-item v-if="linkpath != ''">{{linkpath}}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="page" v-if="!isClicked || isClicked == 'add' || isClicked == 'edit'">
       <!-- 顶部查询框 -->
      <section class="seaerch-wrapper">
        <el-form :model="searchform" class="search-form"  style="margin-left: -20px;">
          <el-form-item label="平台" label-width="100px">
            <el-select v-model="searchform.platform_code" placeholder="请选择" size="small" clearable>
              <el-option
                      v-for="item in plateList"
                      :key="item.dictCode"
                      :value="item.dictCode"
                      :label="item.dictName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="店铺名称" label-width="100px">
            <el-input v-model="searchform.shopname" placeholder="请输入" autocomplete="on" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item label="旺旺" label-width="100px">
            <el-input v-model="searchform.wangwang" placeholder="请输入" filterable  autocomplete="on" size="small" clearable></el-input>
          </el-form-item>
					<el-form-item label="开店经销商" label-width="100px">
            <el-input v-model="searchform.dealername" placeholder="请输入" filterable  autocomplete="on" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" class="search-btn" @click="QueryTable()">查询</el-button>
          </el-form-item>
        </el-form>
      </section>
      <!-- min-height: calc(100% - 146px); -->
      <section class="content-warpper" style="min-height: 700px;">
        <!-- 操作按钮 -->
        <el-row v-if="userData.logintype != 'HCMSUB' && userData.bmcid != '2881'">
          <el-button size="small" icon="el-icon-plus" type="primary"  @click.stop="newAddStore">新增</el-button>
          <el-button size="small" type="default"  @click.stop="mulDeleteClick">批量删除</el-button>
          <el-button size="small" type="default"  @click.stop="mulImportClick">批量导入</el-button>
          <el-button size="small" type="default"  @click.stop="importTempdownClick" :loading="Tempdown">导入模板下载</el-button>
          <el-button size="small" type="default"  @click.stop="downLoadDataClick" :loading="LoadData">下载数据</el-button>
          <el-button size="small" class="changeBtn" type="default" @click.stop="changeHistoryClick">变更历史</el-button>
          <el-button size="small" type="default" @click="massTransfer">批量转移</el-button>
        </el-row>
        <!-- 数据表格 -->
        <el-row>
          <dataTable
              ref="dataTable"
              :isNotice="true"
              :tableData="tableData"
              :colums="gridColumns"
              type="selection" showIndex="index"
              :pageConfig="pageOption"
              @searchTable="pageChange"
              @selectionChange="selectionChange"
              @rowClick="linkDetail"
              @checkAll="selectAll"
            >
            <el-table-column slot="operation" label="营业执照地址" width="320" v-if="shoptype == 2">
              <template slot-scope="scope">
                {{ scope.row.province }}{{ scope.row.city }}{{ scope.row.district }}{{ scope.row.businesslicenseaddress }}
              </template>
            </el-table-column>
            <el-table-column slot="operation" label="公司名称" width="320" v-if="shoptype == 2">
              <template slot-scope="scope">
                {{ scope.row.companyname }}
              </template>
            </el-table-column>
            <!-- 操作列 -->
            <el-table-column slot="operation" label="操作" width="150px" class-name="operate" fixed="right" v-if="userData.logintype != 'HCMSUB' && userData.bmcid != '2881'">
              <template slot-scope="scope">
                <span class="op-btn edit"  @click.stop="handleEdit(scope.$index, scope.row)"><i class="el-icon-edit-outline"></i> 编辑</span><span class="verline">|</span>
                <el-dropdown>
                  <span class="el-dropdown-link op-btn" @click.stop="">
                    <i class="el-icon-more"></i>更多
                  </span>
                  <el-dropdown-menu slot="dropdown" trigger.stop="click">
                    <el-dropdown-item @click.native="changeType(scope.row,1)">移入授权</el-dropdown-item>
                    <el-dropdown-item v-if="shoptype == 2" @click.native="changeType(scope.row,3)">移入黑名单</el-dropdown-item>
                    <el-dropdown-item v-if="shoptype == 3" @click.native="changeType(scope.row,2)">移入灰名单</el-dropdown-item>
                    <el-dropdown-item @click.native="changeHistoryClick(scope.row)">变更历史</el-dropdown-item>
                    <el-dropdown-item @click.native="handleDelete(scope.$index, scope.row)">删除</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </dataTable>
        </el-row>
        <!-- 批量导入弹框 -->
        <importModal :modalInfo="importmodelInfo" :columsDataErr="gridColumns" @reqTableData="reqTableData"/>
        <!-- 详情弹框 -->
        <shopRightDetail :modalInfo="detailModalInfo" :editModalInfo="addmodelInfo" ref="detailModal" @editClick="editClick"  @reqDetail="linkDetail" @reqTableData="reqTableData"/>
      </section>
    </div>
    <!-- 新增/编辑授权店铺 -->
    <newAddModel ref="newAddModelShow" :shoptype="shoptype" :modalInfo="addmodelInfo" @reqTableData="reqTableData" @getIsshow="isShowAddmodal" v-show="isClicked == 'add' || isClicked == 'edit'"/>
    <!-- 变更历史 -->
    <changehistory :modalInfo="historymodelInfo" ref="changeHistory" v-if="isClicked == 'changehistory'"/>
    <!-- 删除 -->
    <delElDialog ref="delDialog" @deldata="deldata"/>
    <!-- 批量转移 -->
    <el-dialog title="批量转移" :visible.sync="transferShow" width="400px" style="margin-top: 10%;" id="direct">
      <el-form style="margin-top: 10px;">
        <el-form-item label="店铺类型" :label-width="formLabelWidth" prop="name">
          <el-select v-model="blackShoptype" placeholder="请选择" size="mini" style="width: 280px;">
            <el-option
              v-for="item in shopArr"
              :key="item.value"
              :label="item.name"
              :value="item.value"
              v-if="item.value != shoptype">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="transferSure()" size="small">确 定</el-button>
        <el-button @click="transferShow = false" size="small" type="TheCustom" style="margin-left: 10px;">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 批量转移 -->
  </div>
</template>

<script>
import dataTable from "components/dataTable";
import delElDialog from "components/delElDialog"; //删除
import newAddModel from "./addNewModel"; //新增/编辑
import changehistory from "../commonChangeHistory/changeHistory"; //变更历史
import importModal from "../commonImportModal/importModel";  //批量导入
import shopRightDetail from "./shopRightDetail"; //详情弹框
import { renderShopName ,renderProductInfo,renderDialog} from "@/libs/renderCommon";
import {fetchGet ,fetchPost} from "../../../libs/reqCommon";
import { mapGetters } from 'vuex';
import {mapActions} from "vuex";
let titles = [
  { title: "平台", key: "platformname",width:80 },
  { title: "店铺名称", key: "shop_name",width:280 },
  { title: "旺旺名称", key: "wangwang",width:280 },
  { title: "店铺首页地址", key: "shop_url",width:320 },
  { title: "开店经销商",key:"dealername",width:320 },
  { title: "供货经销商", key:"supplydealername",width:320 },

  { title: "法人名称", key:"corporatename",width:320 },
  { title: "法人联系方式", key:"corporatephone",width:320 },
  // { title: "营业执照地址", key:"businesslicenseaddress",width:320 },

  { title: "业务人员", key:"businesspeople",width:320 },
  { title: "业务联系方式", key:"businesspeoplecontact",width:320 },
  { title: "店铺运营负责人", key:"shopoperate",width:320 },
  { title: "店铺运营联系方式",key:"shopoperatecontact",width:320},
  { title: "经销商负责人", key:"dealeroperate",width:320 },
  { title: "经销商联系方式", key:"dealeroperatecontact",width:320},
  { title: "备注", key:"remark"}
];

export default {
  components: {dataTable,importModal ,newAddModel ,changehistory ,shopRightDetail ,delElDialog},
  props:{
    shoptype:{
      type:String,
      default:""
    },
    changeModule:{
      type:String,
      default:"HcmShopGreyList"
    }
  },
  data() {
    return {
      blackShoptype: '1',
      shopArr: [{
        name: '授权店铺',
        value: '1',
      },{
        name: '灰名单',
        value: '2',
      },{
        name: '黑名单',
        value: '3',
      }],
      userData: JSON.parse(localStorage.getItem('userData')),
      Tempdown: false,
      LoadData: false,
      tableloading: false,
      linkpath:'',
      searchform:{},
      formLabelWidth: "90px",
      isClicked:'',isActive:'add',
      valueId:null,
      props:{                // 配置项（必选）
        value:'value',
        label: 'title',
        children: 'children'
      },

      //灰名单2
      query:{
        pageNo:1,pageSize:10
      },
      pageOption:{isPage:true,total:0},
      gridColumns:[],
      tableData: [],
      addmodelInfo:{}, // 新增/编辑弹框属性

      setModalInfo:{},//设置表头弹框属性
      addField:[],//新增字段
      basicField:[],//基础字段
      selected:[],//已选择的项

      historymodelInfo:{},//变更历史
      importmodelInfo:{},//批量导入弹框属性
      detailModalInfo:{},//详情弹框属性
      transferShow: false,//批量转移弹框
    };
  },
  computed: {
    ...mapGetters(["plateList"])
	},
  created() {
    this.query.shoptype = this.shoptype;
    this.initShopList();
  },
  methods: {
    massTransfer() {
      if (this.selected.length == 0) {
        this.$message.error('请先选择列表项！');
      } else {
        this.transferShow = true
      }
    },
    // 确认批量转移
    transferSure() {
      let params={
        shoptype:this.blackShoptype,
        ...this.searchform
      }
      if (this.selected.length > 10) {
        params.id = 'checkAll'
      } else {
        params.id = this.selected.join(",")
      }
      fetch({
        url: "/hcm/hcmShop/changeTypeAll",
        method: "post",
        data: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let {data}=res
        if(res.status == '10000'){
          this.transferShow = false
          this.$message({
            message: '批量转移成功',
            type: 'success'
          });
          this.reqTableData();
        } else {
          this.$message.error(res.message);
        }
      })
    },
    ...mapActions(['reqPlateList']),
    // 下拉树取值
    getValue(value){
      this.valueId = value
      this.searchform.brandtakepeople = value
    },
    // 删除之后更新数据
    deldata() {
      this.query.shoptype = this.shoptype;
      this.initShopList();
    },
    reqTableData(){
      this.getTabledata(this.query);
    },
    isShowAddmodal(val){
      if(!val)
      this.linkpath = '';this.isClicked = '';
      this.$nextTick(()=>{
        this.$refs.dataTable.pageOption.pageSize = this.query.pageSize;
        this.$refs.dataTable.pageOption.pageNo = this.query.pageNo;
      })
      this.getTabledata(this.query)
    },
    // 初始化列表数据
    initShopList(){
      this.reqPlateList();
      this.initTableColum();
      this.getTabledata(this.query);
    },
    // 点击搜索查询
    searchClick(){
      if(!this.Keywordname){
        this.$message({
          message: '请先输入关键字',
          type: 'warning'
        })
      }else {
        this.query.keywordname  = this.Keywordname;
        this.getTabledata(this.query);
      }
    },
    	// 查询
	QueryTable(){
			let query = {
        pageNo:1,
        pageSize:this.query.pageSize,
        shoptype:this.shoptype,
				...this.searchform
			}
			this.getTabledata(query);
		},
    // 点击分页查询
    pageChange(pageOption){
      this.query.pageNo = pageOption.pageNo;
      this.query.pageSize = pageOption.pageSize;
       this.query = {
        ...this.query,
        ...this.searchform
      }
      this.getTabledata(this.query);
    },
    // 表格数据
    getTabledata(query){
      this.tableloading = true
      fetch({
        url: "/hcm/hcmShop/getBlackListPageByBmc",
        method: "get",
        params: {...query,...this.searchform},
        noFormat: true,
        responseType: "text"
      })
      .then(result => {
        this.tableloading = false
        let res = JSON.parse(result);
          for (let i = 0; i < this.gridColumns.length; i++) {
          //店铺首页地址
          renderProductInfo(this.gridColumns[i],'shop_url','shop_url',this);
          // 店铺名称
          renderShopName(this.gridColumns[i],'shop_name',null,this);
          }
        this.tableData = res.data.content;
        this.$set(this.pageOption,"total",res.data.totalElements);
      })
      .catch(err => {
        console.log(err)
      })
    },
    // 初始化表头
    initTableColum(){
      this.gridColumns = [];
      console.log(titles)
      for (var item of titles) {
        let obj = {
          label: item.title,
					prop: item.key,
					width:item.width
        };
        this.gridColumns.push(obj);
      }
      console.log(this.gridColumns)
      this.setModalInfo.selfFields = this.addField;
    },
    // 店铺详情（右侧弹框）
    linkDetail(row){
      let query = {
        shopId:row.id
      }
      this.$refs.detailModal.loading = true;
      fetchGet("hcm/hcmShop/getBlackById",query).then(res =>{
        if(res.status == "10000"&&res.data){
          this.detailModalInfo = {
            isShow:true,
      			detail:res.data,
      			row:row
          }
        }else{
          this.$message.info("暂无详情数据或获取详情失败！");
        }
        this.$refs.detailModal.loading = false;
      });
      this.getTabledata(this.query);
    },
    // 删除请求
    reqDelete(query,url){
      fetch({
        url: url,
        method: "post",
        params: query,
        noFormat: true,
        responseType: "text"
      })
      .then(result => {
        let res = JSON.parse(result);
        if(res.status == '10000'){
          this.$message({
            message: '操作成功！',
            type: res.message
          })
          this.getTabledata(this.query)
        }else{
          this.$message.error(res.message);
        }
      })
      .catch(err => {
        console.log(err)
      })
    },
    selectAll(isAll){
      if(isAll) this.selected.length = this.pageOption.total;
    },
    selectionChange(data){
      let ids = [];
      for(var i=0;i<data.length;i++){
        ids.push(data[i].id);
      }
      this.$set(this,'selected',ids)
    },
    // 批量删除
    mulDeleteClick(){
      if(this.selected.length == 0){
        this.$message.error('请先选择列表项！');
      }else{
        this.isActive = 'muldelete'
        let query = {
					shoptype:this.shoptype,
					...this.searchform
        }
        let url = "hcm/hcmShop/DeleteBlack"
        let func = this.reqDelete
        // 删除全部
        if(this.selected.length == this.pageOption.total){
          query = {
            ids:"checkAll",
						shoptype:this.shoptype,
						...this.searchform
          }
          let info = {
            title:`你确认要删除全部的${this.shoptype==2?'灰名单':'黑名单'}信息吗?`,
            infoccc:'删除后',infored:`${this.shoptype==2?'灰名单':'黑名单'}信息将会被全部彻底删除`
          }
          // renderDialog(info,url,query,func,this)

          this.$refs.delDialog.dialogData(info,url,query);
        }else{
          query.ids = String(this.selected);
          let info = {
            title:`你确认要删除${this.selected.length}条${this.shoptype==2?'灰名单':'黑名单'}信息吗？`,
            infoccc:'删除后',infored:`这${this.selected.length}条${this.shoptype==2?'灰名单':'黑名单'}信息将会被彻底删除`
          }
          // renderDialog(info,url,query,func,this)
          this.$refs.delDialog.dialogData(info,url,query);
        }
      }
    },
    // 删除当前行
    handleDelete(index,item){
      let query = {
        ids:item.id,
				shoptype:item.shoptype,
				...this.searchform
      }
      let url = "hcm/hcmShop/DeleteBlack"
      let func = this.reqDelete
      let info = {
        title:`你确认要删除该${this.shoptype==2?'灰名单':'黑名单'}信息吗?`,
        infoccc:'删除后',infored:`该${this.shoptype==2?'灰名单':'黑名单'}信息将会彻底删除`
      }
      renderDialog(info,url,query,func,this)
    },
    // 批量导入
    mulImportClick(){
      this.isActive = 'mulimport'
      this.importmodelInfo = {
        isShow:true,
        shoptype:this.shoptype,
        url:'/hcm/hcmShop/readExcelFile'
        }
		},
		getParamUrl(data) {
      let url = "";
      for (var k in data) {
        let value = data[k] && data[k] !== undefined ? data[k] : "";
        url += `&${k}=${encodeURIComponent(value)}`;
      }
      return url ? url.substring(1) : "";
    },
    // 下载数据
    downLoadDataClick(){
			this.isActive = 'downdata'
			let params = this.getParamUrl(this.searchform);
      console.log(params)
			let url = `hcm/hcmShop/exportExcelBlackShop?istemplet=2&&shoptype=${this.shoptype}&`+params;
      window.open(url)
    },
    // 导入模板下载
    importTempdownClick(){
      this.Tempdown = true
      let params = {
        istemplet: "1",
        shoptype: this.shoptype,
      }
      fetch({
          url: "/hcm/hcmShop/exportExcelBlackShop",
          method: "get",
          params:params,
          noFormat: true,
          responseType: "blob"
      })
      .then((res)=>{
        let name
        if (this.shoptype == 3) {
          name = '黑名单店铺档案数据导入模板.xlsx'
        } else {
          name = '灰名单店铺档案数据导入模板.xlsx'
        }
        //下载
        let url = window.URL.createObjectURL(new Blob([res]))
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', name)
        document.body.appendChild(link)
        link.click()
        this.Tempdown = false
      })
    },
     // 变更历史
    changeHistoryClick(row){
      let id = null;
      this.historymodelInfo.modulename = this.changeModule;
      if(row){
        id = row.id;
      }
      this.isClicked = 'changehistory';
      this.linkpath = '变更历史';
      let _this = this;
      this.$nextTick(()=>{
        _this.$refs.changeHistory.reqChangeHistory(id);
      })
    },
    // 移入授权/hcm/hcmShop/changeType
    changeType(row,type){
      let query = {
        id:row.id,
        shoptype:type
      }
      let url = "/hcm/hcmShop/changeType"
      let func = this.reqChangeType
      let info = {
        title:`你确认要转化该店铺档案吗？`,
        infoccc:'转化后',infored:`店铺档案信息也会移出${this.shoptype==2?'灰名单':'黑名单'}`
      }
      renderDialog(info,url,query,func,this)
    },
    // 请求变更
    reqChangeType(query,url){
      fetchPost(url,query).then(res =>{
        if(res.status == "10000"){
          this.$message.success('操作成功！');
          this.getTabledata(this.query)
        }else{
          this.$message.error(res.message);
        }
      }).catch((res)=>{
        this.$message.error("请求出错！");
      })
	},
	editClick(payload){
		this.handleEdit(payload.index,payload.row)
	},
    // 编辑事件
    handleEdit(index,row){
      console.log(row.supplydealerid)
      this.isClicked = index || index === 0 ? "edit" : "";
  	  this.linkpath = index || index === 0 ? "编辑" : "";
  	  // 供货经销商处理
  	  let supplydealerid = row.supplydealerid?row.supplydealerid.split(","):[];
  	  row.supplydealerid = [];
  	  for(let i=0;i<supplydealerid.length;i++){
  		row.supplydealerid[i] = Number(supplydealerid[i])
        }
  	  row.dealerid = Number(row.dealerid) || null;
      this.addmodelInfo = {
        shoptype:this.shoptype,
        plateform:this.plateList, //平台
    		form:{...row,shopid:row.id},
    		row:row,
    		ispanelEdit:index || index === 0 ?  false : true
      }
      if (index != null) {
        this.$refs.newAddModelShow.ntm(this.linkpath)
      }
    },
    newAddStore(){
      this.isClicked = "add";
      this.linkpath = "新增";
      this.addmodelInfo = {
        shoptype:this.shoptype,
        plateform:this.plateList, //平台
        form:{}
      }
      this.$refs.newAddModelShow.ntm(this.linkpath)
    }

  },
};
</script>

<style lang="scss">
$highColor:#108cee;
.linkpath{
  &:hover{
    cursor: pointer;
    .el-breadcrumb__inner{
      color:$highColor!important;
    }
  }
}
.changeBtn{
  float: right;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}
.el-icon-arrow-down {
  font-size: 12px;
}
</style>
